import { SignatureWUT } from '@wix/form-fields/viewer-wut';

export default SignatureWUT;
